module.exports = __webpack_public_path__ + "img/1_new_born_baby.4a42d682.jpeg";